import React, { useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Column,
  Paging,
  Sorting,
} from 'devextreme-react/data-grid';
import { columnSchema } from './gridConfig';
import DataGrid from 'components/devExtreme/DataGrid';

const styles = theme => ({
});

const LocationVerificationGrid = ({ nearMatches, searchWithPm, width }) => {
  const gridRef = useRef(); // Per-instance ref - the grid can be mounted in the modal and the create panel at the same time

  const handleContextMenu = e => {
    if (e.target === 'content') {
      // e.items can be undefined
      e.items = e.items ?? [];
      if (e.row) {
        const ref = gridRef.current.instance;
        if (!ref.isRowSelected(e.row.key)) {
          ref.selectRows([e.row.key]);
        }
        e.items = getContextItems(e);
      }
    }
  }

  const getContextItems = e => {
    console.log(e)
    const items = [];

    items.push({
      text: `Search with address`,
      onItemClick: () => searchWithPm({
        referenceId: 0,
        street: e.row.data.street,
        zipCode: e.row.data.zipcode,
        city: e.row.data.city,
        state: e.row.data.state
      }, `${e.row.data.street}, ${e.row.data.zipcode}, ${e.row.data.city}, ${e.row.data.state}`),
      beginGroup: true
    });
    return items;
  }

  const dataSource = nearMatches?.length
    ? nearMatches.map((match, index) => {
      return {
        key: index,
        ...match
      }
    })
    : []

  return (
    <DataGrid
      ref={gridRef}
      dataSource={dataSource}
      keyExpr='key'
      allowColumnResizing={true}
      columnResizingMode='widget'
      showRowLines={true}
      showColumnLines={true}
      focusedRowEnabled={true}
      height='160px'
      width={width ?? '800px'}
      onContextMenuPreparing={handleContextMenu}
      visible={nearMatches?.length > 0}
    >
      <Sorting mode={'multiple'} />
      <Paging
        defaultPageSize={100}
        enabled={true}
      />
      {columnSchema.map(({ field, displayName, width, type, format, visible, headerFilter, sortIndex, sortOrder }) => {
        return (
          <Column
            key={field}
            dataField={field}
            caption={displayName}
            // minWidth={width}
            width={'auto'}
            dataType={type}
            format={format}
            visible={visible === false ? false : true}
            sortIndex={sortIndex}
            sortOrder={sortOrder}
          />
        )
      })}
      <Column width='auto' showInColumnChooser={false} visibleIndex={9999} />
    </DataGrid>
  )
}

export default withStyles(styles)(LocationVerificationGrid);
